import { all, takeLatest, call, put } from 'redux-saga/effects';

import { ERROR } from '@coconut/constants/apiStatus';

import {
  types,
  appLaunchSuccess,
  appLaunchFailed,
} from '@coconut/services/redux/app';
import { fetchProfileSuccess } from '@coconut/services/redux/profile';

import { saveCookieFromUserData } from '@coconut/services/cookies';
import { changeTab } from '@coconut/services/redux/questionList';
import { fetchBankInfoFieldSuccess } from '@coconut/services/redux/bank';

import { ONGOING } from '@coconut/constants/questionListTabNames';
import { TUTOR } from '@coconut/constants/userRole';
import {
  NORMAL_QUESTION,
  TIME_BASE_QUESTION,
} from '@coconut/constants/questionType';

import * as apis from '@coconut/services/apis/app';

import { getCapitalizedRegionLang } from '@coconut/utils/langParser';

/**
 * API appLaunch response the data structure with question type, 'normal' and 'time_based'.
 * Transform the structure to fit the UI logic.
 * @param {object} rawData the search_subjects of appLaunch response
 */
function transformSearchSubjects(rawData) {
  const questionTypes = [NORMAL_QUESTION, TIME_BASE_QUESTION];
  const searchSubjects = questionTypes.reduce((subjects, type) => {
    if (!rawData[type]) {
      return subjects;
    }

    subjects.push(...transformSubjectWithQuestionType(type, rawData[type]));
    return subjects;
  }, []);

  return searchSubjects;
}

/**
 * Transform subjects with append the question type
 * @param {string} type question type
 * @param {array} subjects subjects
 */
function transformSubjectWithQuestionType(type, subjects) {
  return subjects.map((subject) => ({
    ...subject,
    type,
  }));
}

function* appLaunchFlow(action) {
  const { lang } = action.payload;

  try {
    const response = yield call(apis.appLaunch, getCapitalizedRegionLang(lang));

    if (response.status === ERROR) {
      throw new Error(response.error_code);
    }

    const {
      rate_messages: rateMessages,
      search_subjects: searchSubjects,
      user: {
        country_code: countryCode,
        first_name: firstName,
        last_name: lastName,
        profile_pic_url: avatar,
        role: { name: role },
        role_status,
        snapask_uid: userId,
        username,
        email,
        region: { name: region, bank_need_column: bankNeedColumn },
        personal_pubnub_channel: personalPubnubChannel,
        is_profile_completed: isProfileCompleted,
        profile_completion_message: profileCompletionMessage,
      } = {},
      subjects,
      typeform_url: typeformUrl,
      web_opend_qa_notify_pubnub_channel: webOpendQaNotifyPubnubChannel,
      ui_hide_settings: {
        time_based_question_entry: hideTimeBasedQuestionEntry,
      },
    } = response.data;

    const profile = {
      role,
      roleStatus: role_status,
      userId: userId.toString(),
      avatar,
      countryCode,
      email,
      region,
      firstName,
      lastName,
      username,
      isProfileCompleted,
      profileCompletionMessage,
    };

    const userData = Object.assign({}, response.data);

    // Saving latest data to cookie
    saveCookieFromUserData(userData);
    yield put(fetchProfileSuccess(profile));

    if (profile.role === TUTOR) {
      yield put(fetchBankInfoFieldSuccess({ bankNeedColumn }));
      yield put(changeTab(ONGOING));
    }

    yield put(
      appLaunchSuccess({
        subjects,
        rateMessages,
        searchSubjects: transformSearchSubjects(searchSubjects),
        typeformUrl,
        region,
        personalPubnubChannel,
        webOpendQaNotifyPubnubChannel,
        hideTimeBasedQuestionEntry,
        locale: lang,
      })
    );
  } catch (err) {
    yield put(appLaunchFailed(err.message));
  }
}

export default function* () {
  yield all([takeLatest(types.APP_LAUNCH, appLaunchFlow)]);
}



// WEBPACK FOOTER //
// ./src/services/sagas/app.js